import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'

import { compose } from 'recompose'

import Enhancer from './RugCardDetailedEnhancer'

import RugCardDetailedActions from 'Components/RugCardDetailed/RugCardDetailedActions'
import RugCardDetailedHeader from 'Components/RugCardDetailed/RugCardDetailedHeader'
import RugCardDetailedInformation from 'Components/RugCardDetailed/RugCardDetailedInformation'
import RugCardDetailedMeta from 'Components/RugCardDetailed/RugCardDetailedMeta'
import RugCardDetailedStatus from 'Components/RugCardDetailed/RugCardDetailedStatus'

import * as helpers from 'Global/Helpers/rugHelpers'
import { hasPermission } from 'Components/Permissions/utils'

const RugCardDetailed = props => {
  const {
    createRequest,
    deleteRequest,
    rug,
    showCreateReservationModal,
    toggleIsMasterpiece,
    toggleMarkedForDesigners,
    user,
    userPermissions,
  } = props

  const isAllowedToSeeStatus = hasPermission('rug.field.status', userPermissions)

  return (
    <Card color={isAllowedToSeeStatus ? helpers.getStatus(rug).color : null} raised={isAllowedToSeeStatus} fluid>
      <RugCardDetailedHeader rug={rug} />

      <RugCardDetailedInformation rug={rug} />

      <RugCardDetailedStatus rug={rug} />

      <RugCardDetailedMeta rug={rug} />

      <RugCardDetailedActions
        createRequest={createRequest}
        deleteRequest={deleteRequest}
        rug={rug}
        showCreateReservationModal={showCreateReservationModal}
        toggleIsMasterpiece={toggleIsMasterpiece}
        toggleMarkedForDesigners={toggleMarkedForDesigners}
        user={user}
        userPermissions={userPermissions}
      />
    </Card>
  )
}

RugCardDetailed.propTypes = {
  createRequest: PropTypes.func.isRequired,
  deleteRequest: PropTypes.func.isRequired,
  rug: PropTypes.object.isRequired,
  showCreateReservationModal: PropTypes.func.isRequired,
  toggleMarkedForDesigners: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  userPermissions: PropTypes.array.isRequired,
}

const composed = compose(Enhancer)

export default composed(RugCardDetailed)
